class Map {

    /**
     * @method constructor
     */
    constructor() {
        // Set up variables
        this.modalSelector  = '.modal';
        this.mapSelector    = '.acf-map';
        this.markerSelector = '.marker';

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @since 1.0.0
     * @method init
     * @return void
     */
    init() {
        // Run it
        this.run();
    }

    /**
     * Initialize a map.
     *
     * @since 1.0.0
     * @method initMap
     * @param object ele is the map element
     * @return void
     */
    initMap(ele) {
        // Declare and initialize
        let me          = $(ele);
        let existingMap = me.data('map');
        let markers     = me.find(this.markerSelector);
        let mapArgs;
        let map;

        // If already initialized, resize and recenter
        if (existingMap) {
            google.maps.event.trigger(existingMap, 'resize');

            this.centerMap(existingMap);

            return;
        }

        // Set up map args
        mapArgs = {
            zoom:      me.data('zoom') || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        // Create map
        map = new google.maps.Map(ele, mapArgs);

        // Set up marker storage
        map.markers = [];

        // Add markers
        markers.each((i, marker) => {

            this.initMarker(marker, map);

        });

        // Center map
        this.centerMap(map);

        // Store map instance
        me.data('map', map);
    }

    /**
     * Initialize a marker.
     *
     * @since 1.0.0
     * @method initMarker
     * @param object ele is the marker element
     * @param object map is the Google map instance
     * @return void
     */
    initMarker(ele, map) {
        // Declare and initialize
        let me   = $(ele);
        let lat  = me.data('lat');
        let lng  = me.data('lng');
        let name = me.data('name') || 'View location';
        let latLng;
        let marker;
        let directionsUrl;
        let infoWindow;

        // Set position
        latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };

        // Set directions URL
        directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;

        // Create marker
        marker = new google.maps.Marker({
            position: latLng,
            map:      map
        });

        // Create info window
        infoWindow = new google.maps.InfoWindow({
            content:
                '<div class="acf-map-window">' +
                '<div class="acf-map-window-title">' + name + '</div>' +
                '<a class="acf-map-window-link" href="' + directionsUrl + '" target="_blank" rel="noopener">' +
                'Get Directions' +
                '</a>' +
                '</div>'
        });

        // Open info window on click
        marker.addListener('click', function () {

            infoWindow.open(map, marker);

        });

        // Store marker
        map.markers.push(marker);
    }

    /**
     * Center a map around its markers.
     *
     * @since 1.0.0
     * @method centerMap
     * @param object map is the Google map instance
     * @return void
     */
    centerMap(map) {
        // Declare and initialize
        let bounds = new google.maps.LatLngBounds();

        // Add each marker to bounds
        $.each(map.markers, function (i, marker) {

            bounds.extend(marker.position);

        });

        // Single marker
        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());

            return;
        }

        // Multiple markers
        map.fitBounds(bounds);
    }

    /**
     * Run the map modal bindings.
     *
     * @since 1.0.0
     * @method run
     * @return void
     */
    run() {
        // No maps? No problem
        if (!$(this.mapSelector).length)
            return;

        // Bind Bootstrap modal shown event
        $(this.modalSelector).on('shown.bs.modal', e => {

            // Declare and initialize
            let modal = $(e.currentTarget);

            // Initialize maps inside this modal only
            modal.find(this.mapSelector).each((i, ele) => {

                this.initMap(ele);

            });

        });
    }

}

export default Map;